import * as React from "react";
import { ISvgIconProps, SvgIcon } from '../../../basic-ui-components/icon/svg-icon/svg.icon';


export interface ITickIconProps extends ISvgIconProps {

}

export class TickIcon extends React.Component<ITickIconProps, {}> {
    render() {
        return (
            <SvgIcon {...this.props} viewBox="0 0 24 24">
                <path
                    fill="currentColor"
                    d="M10.064 22L0 11.936L5.032 6.904L10.208 12.08L21.112 1.176L26 6.064L10.064 22Z"
                />
            </SvgIcon>
        );
    }
}
